import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import SildeBundleSort from '../Carousel/SildeBundleSort';
// Import Swiper styles
import 'swiper/swiper.scss';
import './swiper.scss';
import { useSelector } from 'react-redux';
import Translation from 'services/translation.service';
const SwiperComp = ({ type, slides, dispatch, activeSlide, action }) => {
  const colors = {
    gold: '#F59F05',
    silver: '#7C8095',
    bronze: '#B56C10',
    platinum: '#087386',
    all: '#1A1F45',
    free: '#1978CD',
  };
  let component = null;
  const [active, setActive] = useState(0);
  const [swiper, setSwiper] = useState(null);
  const loggedIn = useSelector((state) => state.user.loggedIn);
  const errorLogin = useSelector((state) => state.user.error);
  const { iso } = useSelector((state) => state.layout);

  const location = useLocation();
  const currentURL = location.pathname;
  const handleClick = (slideIndex) => {
    if (swiper) {
      swiper.slideTo(type === 'sort-button' ? slideIndex : slideIndex - 1); // Center the clicked item
      setActive(swiper.activeIndex);
    }
  };

  const getSliderByType = (slide, index) => {
    const activeColor = colors[slide.name?.toLowerCase()] || '#7c8095'; // Fallback to default color if not matched
    const isActive = activeSlide === slide.name;
    if (type === 'join-lebara') {
      component = (
        <SwiperSlide key={index} onClick={() => handleClick(index)}>
          <div
            className={`slider-title-wrapper-join ${
              isActive ? 'active-number-select' : ''
            }`}
            style={{
              color: activeColor,
              borderBottom: isActive ? `8px solid ${activeColor}` : 'none',
            }}
            onClick={() => action(slide)}
          >
            {Translation.key('order_sim_catgry_lbl_' + slide.name)}
          </div>
        </SwiperSlide>
      );
    } else if (type === 'link') {
      if (slide.type === 'offers-for-you') {
        if (!loggedIn && errorLogin) {
          return null;
        }
      }
      component = (
        <SwiperSlide key={index} onClick={() => handleClick(index)}>
          <NavLink
            to={`/${slide.locale}${slide.url}`}
            style={{
              color: '#7c8095',
            }}
            activeStyle={{
              borderBottom: `8px solid #1978CD`,
              color: `#1978CD`,
            }}
            className="slider-link-wrapper"
          >
            {slide.name}
          </NavLink>
        </SwiperSlide>
      );
    } else if (type === 'static-pages') {
      component = (
        <SwiperSlide key={index} onClick={() => handleClick(index)}>
          <NavLink
            to={`/${slide.locale}${slide.url}`}
            style={{
              color: '#7c8095',
            }}
            activeStyle={{
              borderBottom: `8px solid #1978CD`,
              color: `#1978CD`,
            }}
            className="slider-link-wrapper-static"
          >
            {slide.name}
          </NavLink>
        </SwiperSlide>
      );
    } else if (type === 'sort-button') {
      component = (
        <SwiperSlide key={index} onClick={() => handleClick(index)}>
          <SildeBundleSort
            index={index}
            slide={slide}
            activeSlide={activeSlide}
            dispatch={dispatch}
            action={action}
            click={handleClick}
          />
        </SwiperSlide>
      );
      // } else {
      //   component = null;
      // }
    }

    return component;
  };

  let indexInitialSlide = 0;
  if (slides.length && !loggedIn && type === 'link') {
    let newSlides = slides.filter((el) => el.type !== 'offers-for-you');
    slides = newSlides;
  }
  if (slides.length && (type === 'link' || type === 'static-pages')) {
    let route = currentURL.replace(`/${iso}`, '');
    for (let index = 0; index < slides.length; index++) {
      const element = slides[index];
      if (
        element.url === route ||
        element.url + '/' === route ||
        element.url === route + '/'
      ) {
        indexInitialSlide = index;
      }
    }
  }
  if (slides.length && type === 'sort-button') {
    let newSlides = slides.filter(
      (el) => el.filters_options === 'both' || el.filters_options === 'sort'
    );
    slides = newSlides;
  }
  useEffect(() => {
    if (swiper) {
      swiper.slideTo(indexInitialSlide - 1);
    }
  }, [swiper, indexInitialSlide]);

  return (
    <Swiper
      freeMode={true}
      className="my-swiper"
      // centeredSlides={active !== 0}
      // slidesPerView="auto"
      slidesPerView={
        type === 'static-pages'
          ? 2
          : type === 'sort-button'
          ? 1.8
          : type === 'link'
          ? 2.7
          : 3
      }
      onSwiper={setSwiper}
      spaceBetween={type === 'link' ? 22 : 10}
      breakpoints={{
        // When window width is >= 768px
        768: {
          slidesPerView:
            type === 'static-pages' ? 3 : type === 'sort-button' ? 3 : 4,
          spaceBetween: 20,
        },
        // When window width is >= 992px
        992: {
          slidesPerView:
            type === 'static-pages' ? 5 : type === 'sort-button' ? 6 : 8,
          spaceBetween: 10,
        },
      }}
    >
      {slides?.map((slide, index) => getSliderByType(slide, index))}
    </Swiper>
  );
};
export default SwiperComp;
